import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import BackgroundSlideshow from "./components/BackgroundSlideshow";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import AboutUs from "./pages/AboutUs";
import SchedulePickup from "./pages/SchedulePickup";
import "./App.css";

const App: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        {/* Background Slideshow Covers Entire App */}
        <BackgroundSlideshow />

        {/* Main App Content */}
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/schedule-pickup" element={<SchedulePickup />} />
            <Route path="/new-customer" element={<SchedulePickup />} />
            <Route path="/about" element={<AboutUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
